import React, { useContext } from "react"
import { StyleSheet, View } from "react-native"
import { ThemeContext } from "./utility/context/ThemeContext"
import { SkeletonBlock, SkeletonGroup, SkeletonLine } from "./utility/skeleton"

export const AccountsSkeleton = ({
  itemCount = 3,
  cardWidth = 350,
}: {
  itemCount?: number
  cardWidth?: number
}): React.ReactElement => {
  const { theme } = useContext(ThemeContext)
  const { bgMain } = theme.colors
  const clampedCount = Math.max(2, Math.min(6, itemCount))

  return (
    <View style={styles.wrap}>
      <SkeletonGroup>
        <View style={styles.row}>
          {new Array(clampedCount).fill(0).map((_, idx) => (
            <View key={idx} style={[styles.card, { backgroundColor: bgMain, width: cardWidth }]}>
              <SkeletonLine width="80%" height={18} radius={8} />
              <SkeletonLine width="65%" height={12} radius={8} />
              <View style={{ flex: 1 }} />
              <SkeletonLine width="55%" height={10} radius={8} />
              <SkeletonLine width="70%" height={16} radius={8} />
              <View style={{ height: 10 }} />
              <SkeletonLine width="45%" height={10} radius={8} />
              <SkeletonLine width="60%" height={14} radius={8} />

              <SkeletonBlock
                style={styles.gradientOverlay}
                radius={10}
              />
            </View>
          ))}
        </View>
      </SkeletonGroup>
    </View>
  )
}

const styles = StyleSheet.create({
  wrap: {
    width: "100%",
    paddingHorizontal: 16,
    paddingVertical: 6,
  },
  row: {
    flexDirection: "row",
    gap: 10,
  },
  card: {
    aspectRatio: 1.586,
    borderRadius: 10,
    overflow: "hidden",
    paddingVertical: 20,
    paddingHorizontal: 24,
    flexDirection: "column",
    gap: 10,
  },
  gradientOverlay: {
    ...StyleSheet.absoluteFillObject,
    opacity: 0.12,
  },
})

